import { 
    apiRequest,
    cutiUpdate,
    getMinDate,
    checkDate
} from '../../../../../../services/adapters/kepegawaian/cutiService'

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", cutiUpdate, {
            body: query
        }, true)
    }

    fetchMinDate = async (query, cancelToken) => {
        return await apiRequest("get", getMinDate, {
            params: query
        }, true)
    }

    fetchCheckDate = async (query, cancelToken) => {
        return await apiRequest("get", checkDate, {
            params: query
        }, true)
    }
}

export default UpdateRepository